<template>
    <v-combobox
        v-model="decision"
        :items="options"
        :label="label"
        prepend-icon="mdi-chevron-down-circle"
        clearable
        chips>
    </v-combobox>
</template>

<script>
    import { eventBus } from '../../../../../main';
    import {
        CONF_CALENDAR_PROCEEDINGTYPES
    } from '../../../../../config'


    export default {
        name : 'proceedingstypecombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/ProceedingTypesCombo.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/ProceedingTypesCombo.vue >>> mounted');
            this.setProceedingType();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/ProceedingTypesCombo.vue >>> beforeDestroy');
            eventBus.$off('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                decision: null,
                options: CONF_CALENDAR_PROCEEDINGTYPES
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setProceedingType();

            }, // eo value()

            decision(value) {

                this.$emit('input', value);

            }, // eo decision()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods : {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /*******************************************************************
            * onDragend_InSelectedProceedingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedProceedingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/ProceedingTypesCombo.vue >>> onDragend_InSelectedProceedingsList');
                this.decision = params.proObject.typeOfProceeding; // set dropped

            }, // eo function onDragend_InSelectedProceedingsList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setProceedingType()
            *
            * Desc:
            * Note:
            *
            */
            setProceedingType: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/ProceedingTypesCombo.vue >>> setProceedingType');
                me.decision = this.value;

            }, // eo function setProceedingType()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
</style>